import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import '../.../../../../../styles/dashboards/clgstudent/studentprofile.css'
import { fetchStudentProfileData } from '../../../../redux/actions/student_profile_action';
import { useDispatch, useSelector } from 'react-redux';
import { setGetStudentProfileData } from '../../../../redux/reducers/student_profile_reducer';
import { fetchStudentProfileCompletion } from '../../../../redux/actions/student_profilePercentage';
import { setIsSubmitted } from '../../../../redux/reducers/student_profile_reducer';
import { useNavigate } from 'react-router-dom';
import dummy_logo from "../../../../utils/landingpage/images/user-icon-dummy.png"

const PersonalInformation = () => {

    const NewupdatedData = useSelector((state) => state.studentProfile.getStudentProfileData);
    const isSubmitted = useSelector((state) => state.studentProfile.isSubmitted);
    const navigate = useNavigate();

    const [submittedData, setSubmittedData] = useState(null);
    const [updatedData, setUpdatedData] = useState([]);
    // const [isSubmitted, setIsSubmitted] = useState(false);
    const [isEditModelOpen, setIsEditModelOpen] = useState(false);
    const [profileImage, setProfileImage] = useState("");
    const [profileCompletion, setProfileCompletion] = useState("");
    const [resumeFile, setResumeFile] = useState(NewupdatedData?.student_resume_url || null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState("");
    const [isImageLoading, setIsImageLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [collegeName, setCollegeName] = useState("")
    const dispatch = useDispatch();

    useEffect(() => {
        const candidateCollegeName = sessionStorage.getItem("userDetails");

        if (candidateCollegeName) {
            try {
                const parsedData = JSON.parse(candidateCollegeName);
                setCollegeName(parsedData?.student_campus_clg_name || ""); 
            } catch (error) {
                setCollegeName(""); 
            }
        } else {
            setCollegeName(""); 
        }
    }, []);

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        dob: "",
        gender: "",
        currentLocation: "",
        bio: "",
        preferredLocation: "",
        homeState: "",
        homeCity: "",
        expectedSalary: "",
        degree: "",
        institute: "",
        courseName: "",
        courseType: "",
        startingYear: "",
        endingYear: "",
        school: "",
        board: "",
        passingYear: ""
    });

    const [initialValuesSet, setInitialValuesSet] = useState({
        firstName: false,
        lastName: false,
        email: false,
        phone: false,
        dob: false,
        gender: false,
        currentLocation: false,
        bio: false,
        preferredLocation: false,
        homeState: false,
        homeCity: false,
        expectedSalary: false,
        degree: false,
        institute: false,
        courseName: false,
        courseType: false,
        startingYear: false,
        endingYear: false,
        school: false,
        board: false,
        passingYear: false
    });

    const [errors, setErrors] = useState({});

    const fileInputRef = useRef(null);
    const resumeInputRef = useRef(null);

    const capitalizeFirstLetter = (string) => {
        if (!string) return "";
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    useEffect(() => {
        dispatch(fetchStudentProfileData());
        dispatch(fetchStudentProfileCompletion())
    }, [dispatch]);

    useEffect(() => {
        setUpdatedData(NewupdatedData)
        setProfileImage(NewupdatedData?.student_photo_url)
        setResumeFile(NewupdatedData?.student_resume_url)
    }, [NewupdatedData])

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        // const maxSizeInMB = 2;
        const MAX_FILE_SIZE = 700 * 1024;

        if (file) {
            // const fileSizeInMB = file.size / (1024 * 1024);
            // if (fileSizeInMB > maxSizeInMB) {
            //     toast.error("Image size should not exceed 2 MB.");
            //     return;
            // }

            if (file.size > MAX_FILE_SIZE) {
                toast.error("Photo should be within 700KB.");
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => setProfileImage(e.target.result);
            reader.readAsDataURL(file);

            handleImageUploadSubmit();
        }
    };

    const handleDeleteProfilePhoto = async () => {
        try {
            setIsImageLoading(true);
            const accessToken = sessionStorage.getItem("accessToken");
            const userSessionData = sessionStorage.getItem("userDetails");

            if (!accessToken || !userSessionData) {
                toast.error("User session expired. Please log in again.");
                setTimeout(() => {
                    navigate("/login")
                }, 2000);
                return;
            }

            const parsedData = JSON.parse(userSessionData);
            const userId = parsedData.id;

            const config = {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            };

            const payload = {
                student_photo: null,
                student_photo_url: null,
            };

            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/api/student_profile/${userId}/`,
                payload,
                config
            );

            if (response.status === 200) {
                toast.success("Photo Deleted Successfully");
                // fetchData();
                dispatch(fetchStudentProfileData())
            } else {
                toast.error("Failed to delete photo. Please try again.");
            }
        } catch (error) {
            toast.error(
                error.response?.data?.message || "An error occurred. Please try again."
            );
        } finally {
            setIsImageLoading(false);
        }
    };

    const handleResumeUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileExtension = file.name.split(".").pop().toLowerCase();
            const validExtensions = ["docx", "doc", "pdf"];
            const maxSize = 700 * 1024;
            const minSize = 5 * 1024;

            if (
                validExtensions.includes(fileExtension) &&
                file.size <= maxSize &&
                file.size >= minSize
            ) {
                setResumeFile(file);
                handleSubmitResume(file);
            } else {
                let errorMessage = "Please upload file";
                if (file.size < minSize) {
                    errorMessage += " of at least 5KB.";
                } else {
                    errorMessage += " within 700KB in size.";
                }
                setResumeFile(null);
                toast.error(errorMessage); // Display error message using Toastify
            }
        }
    };

    const handleSubmitResume = async (file) => {
        setUploadProgress(0);
        setUploadStatus("");

        if (!file) {
            toast.warn("Please upload a resume.");
            return;
        }

        const userSessionData = sessionStorage.getItem("userDetails");

        const parsedData = JSON.parse(userSessionData);
        const userId = parsedData.id;

        const formData = new FormData();
        formData.append("student_resume", file);

        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/api/student_profile/${userId}/`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentComplete = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setUploadProgress(percentComplete);
                    },
                }
            );

            if (response.status === 200) {
                toast.success("Resume uploaded successfully!");
                dispatch(setGetStudentProfileData(response.data));
                dispatch(fetchStudentProfileCompletion())
                // setUpdatedData(response.data);
                // fetchProfileCompletion();
            } else {
                toast.error("Failed to upload resume.");
            }
        } catch (error) {
            toast.error("Failed to upload resume.");
        } finally {
            setTimeout(() => setUploadProgress(0), 1500);
        }
    };

    const handleImageUploadSubmit = async () => {
        const userSessionData = sessionStorage.getItem("userDetails");
        const parsedData = JSON.parse(userSessionData);
        const userId = parsedData.id;

        try {
            setIsImageLoading(true);
            const file = fileInputRef.current.files[0];
            if (!file) return toast.error("Please select an image to upload.");

            const formData = new FormData();
            formData.append("student_photo", file);

            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/api/student_profile/${userId}/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
                    },
                }
            );

            if (response.data) {
                dispatch(setGetStudentProfileData(response.data));
                dispatch(fetchStudentProfileCompletion());
                toast.success("Profile photo uploaded successfully.");
            }
        } catch (error) {
            if (error.response) {
                // Check for 413 status
                if (error.response.status === 413) {
                    toast.error("Image size is too large. Please upload an image within 700KB.");
                } else {
                    toast.error(error.response.data?.message || "An error occurred while uploading.");
                }
            } else {
                toast.error(" Please upload an image within 700KB");
                setProfileImage(NewupdatedData?.student_photo_url)
            }
        } finally {
            setIsImageLoading(false);
        }
    };

    const today = new Date();
    const maxDate = new Date(today.setFullYear(today.getFullYear() - 10)).toISOString().split("T")[0];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors({ ...errors, [name]: "" });
    };

    const handleInputEditChange = (field, value) => {
        if (!initialValuesSet[field]) {
            setInitialValuesSet((prev) => ({ ...prev, [field]: true }));
        }
        // placementOfficerEditFormik.setFieldValue(field, value);
        setFormData({
            ...formData,
            [field]: value,
        });
    };

    const validate = () => {
        let tempErrors = {};
        let isValid = true;

        // if (!formData.phone) {
        //     tempErrors.phone = "Phone number is required";
        //     isValid = false;
        // } else if (formData.phone.length < 10) {
        //     tempErrors.phone = "Phone number must be at least 10 digits";
        //     isValid = false;
        // }
        if (!formData.dob) {
            tempErrors.dob = "Date of Birth is required";
            isValid = false;
        }
        if (!formData.gender) {
            tempErrors.gender = "Gender is required";
            isValid = false;
        }
        if (!formData.currentLocation) {
            tempErrors.currentLocation = "Current Location is required";
            isValid = false;
        }
        if (!formData.bio) {
            tempErrors.bio = "Bio is required";
            isValid = false;
        }
        if (!formData.preferredLocation) {
            tempErrors.preferredLocation = "Preferred Location is required";
            isValid = false;
        }
        if (!formData.homeState) {
            tempErrors.homeState = "Home State is required";
            isValid = false;
        }
        if (!formData.homeCity) {
            tempErrors.homeCity = "Home City is required";
            isValid = false;
        }
        if (!formData.expectedSalary) {
            tempErrors.expectedSalary = "Expected Salary is required";
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    const handlePersonalSubmit = async (event) => {
        event.preventDefault();

        if (!validate()) return;

        const accessToken = sessionStorage.getItem("accessToken");

        const userSessionData = sessionStorage.getItem("userDetails");
        const parsedData = JSON.parse(userSessionData);
        const userId = parsedData.id;

        const payload = {
            first_name: formData.firstName || updatedData.first_name || "",
            last_name: formData.lastName || updatedData.last_name || "",
            phone_no: formData.phone || updatedData.phone_no || null,
            dob: formData.dob || updatedData.dob || null,
            gender: formData.gender || updatedData.gender || null,
            current_location:
                formData.currentLocation || updatedData.current_location || null,
            about: formData.bio || updatedData.bio || null,
            preferred_location:
                formData.preferredLocation || updatedData.preferred_location || null,
            state: formData.homeState || updatedData.state || null,
            city: formData.homeCity || updatedData.city || null,
            expected_salary:
                formData.expectedSalary || updatedData.expected_salary || null,
        };

        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };

        try {
            setIsLoading(true)
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/api/student_profile/${userId}/`,
                payload,
                config
            );
            if (response.status === 200) {
                // setIsSubmitted(true);
                dispatch(setIsSubmitted(true))
                setSubmittedData(response.data);
                // fetchProfileCompletion();
                toast.success("Added Successfully");
                // setUpdatedData(response.data);
                dispatch(setGetStudentProfileData(response.data));
                dispatch(fetchStudentProfileCompletion())
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    dob: "",
                    gender: "",
                    currentLocation: "",
                    bio: "",
                    preferredLocation: "",
                    homeState: "",
                    homeCity: "",
                    certificateCourseName: "",
                    certificateInstitute: "",
                    certificateType: "",
                    specialization: "",
                    certificateStartingYear: "",
                    certificateEndingYear: "",
                    certificateValidity: "",
                    skills: "",
                    qualifications: [],
                    employments: [],
                    certificates: [],
                });
            } else {
                toast.error(errors);
            }
        } catch (error) {
            toast.error(errors);
        } finally {
            setIsLoading(false)
        }
    };

    const editPersonalDetails = async (event) => {
        event.preventDefault();

        if (formData.phone && (formData.phone?.length < 10 || formData.phone?.length > 10)) {
            toast.error("Phone Number Should be 10 digit")
            return;
        }

        const accessToken = sessionStorage.getItem("accessToken");
        const userSessionData = sessionStorage.getItem("userDetails");
        const parsedData = JSON.parse(userSessionData);
        const userId = parsedData.id;

        const payload = {
            first_name: formData.firstName || updatedData.first_name || "",
            last_name: formData.lastName || updatedData.last_name || "",
            phone_no: formData.phone || updatedData.phone_no || null,
            dob: formData.dob || updatedData.dob || null,
            gender: formData.gender || updatedData?.gender || null,
            current_location:
                formData.currentLocation || updatedData.current_location || null,
            about: formData.bio || updatedData.about || null,
            preferred_location:
                formData.preferredLocation || updatedData.preferred_location || null,
            state: formData.homeState || updatedData.state || null,
            city: formData.homeCity || updatedData.city || null,
            expected_salary:
                formData.expectedSalary || updatedData.expected_salary || null,
        };

        if (Object.keys(payload).length === 0) {
            return;
        }

        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };

        try {
            setIsLoading(true)
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/api/student_profile/${userId}/`,
                payload,
                config
            );
            if (response.status === 200) {
                // setIsSubmitted(true);
                dispatch(setIsSubmitted(true))
                setSubmittedData(response.data);
                // fetchProfileCompletion();
                dispatch(setGetStudentProfileData(response.data));
                setUpdatedData(response.data);
                setIsEditModelOpen(false);
                toast.success("Added Successfully");
                // setFormData({
                //     firstName: "",
                //     lastName: "",
                //     email: "",
                //     phone: "",
                //     dob: "",
                //     gender: "",
                //     currentLocation: "",
                //     bio: "",
                //     preferredLocation: "",
                //     homeState: "",
                //     homeCity: "",
                //     expectedSalary: "",
                // });

                setInitialValuesSet({
                    firstName: false,
                    lastName: false,
                    email: false,
                    phone: false,
                    dob: false,
                    gender: false,
                    currentLocation: false,
                    bio: false,
                    preferredLocation: false,
                    homeState: false,
                    homeCity: false,
                    expectedSalary: false,
                    degree: false,
                    institute: false,
                    courseName: false,
                    courseType: false,
                    startingYear: false,
                    endingYear: false,
                    school: false,
                    board: false,
                    passingYear: false
                });

            } else {
                toast.error(errors);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            setIsLoading(false)
        }
    };

    const handleEditClick = () => {
        // setIsSubmitted(false);
        dispatch(setIsSubmitted(false))
        setIsEditModelOpen(!isEditModelOpen);
    };

    const handleEditCancel = () => {
        dispatch(setIsSubmitted(true))
        setIsEditModelOpen(false);
    };

    return (<>
        <div className="epf-header student_epf_header flex items-center justify-between p-6 bg-white rounded-lg shadow-md pb-2">
            <div className="epf-image-wrapper relative">

                {/* <img
                    src={profileImage || "default-image.jpg"}
                    alt="ProfilePhoto"
                    className="epf-profile-pic student_epf_profile_pic w-20 h-20 rounded-full object-cover"
                /> */}

                {!isImageLoading ? (
                    <img
                        src={profileImage || dummy_logo}
                        alt="ProfilePhoto"
                        className="epf-profile-pic student_epf_profile_pic w-20 h-20 rounded-full object-cover"
                    />
                ) : (
                    <div className="epf_loading_image_container epf-loading-placeholder w-20 h-20 flex items-center justify-center bg-gray-200 rounded-full">
                        <span>Uploading...</span>
                    </div>
                )}

                {profileImage ?
                    (<button
                        type="button"
                        className="epf-upload-trigger bg-blue-500 rounded-full p-2 flex items-center justify-center cursor-pointer"
                        onClick={handleDeleteProfilePhoto}
                        aria-label="Upload Profile Picture"
                    >
                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.9561 4.07812C13.9412 4.07812 13.9189 4.07812 13.8966 4.07812C9.95984 3.6837 6.03055 3.53486 2.13847 3.92928L0.620335 4.07812C0.307778 4.10788 0.0324298 3.88463 0.00266245 3.57207C-0.0271049 3.25951 0.19615 2.99161 0.501265 2.96184L2.0194 2.813C5.97846 2.41115 9.9896 2.56742 14.0082 2.96184C14.3133 2.99161 14.5366 3.26696 14.5068 3.57207C14.4845 3.8623 14.2389 4.07812 13.9561 4.07812Z" fill="#FFFFFF" />
                            <path d="M4.65464 3.3265C4.62487 3.3265 4.5951 3.3265 4.55789 3.31906C4.26022 3.26697 4.05185 2.97673 4.10394 2.67906L4.26766 1.70418C4.38673 0.989764 4.55045 0 6.2844 0H8.23416C9.97555 0 10.1393 1.02697 10.2509 1.71162L10.4146 2.67906C10.4667 2.98418 10.2583 3.27441 9.96066 3.31906C9.65555 3.37115 9.36532 3.16278 9.32067 2.86511L9.15695 1.89767C9.05276 1.25023 9.03043 1.12372 8.2416 1.12372H6.29184C5.50301 1.12372 5.48812 1.2279 5.3765 1.89023L5.20533 2.85766C5.16068 3.13301 4.92254 3.3265 4.65464 3.3265Z" fill="#FFFFFF" />
                            <path d="M9.64788 16H4.87022C2.27302 16 2.16884 14.5637 2.08698 13.4028L1.60326 5.90889C1.58093 5.60378 1.81907 5.33587 2.12419 5.31355C2.43674 5.29866 2.69721 5.52936 2.71953 5.83448L3.20325 13.3284C3.28511 14.4596 3.31488 14.8837 4.87022 14.8837H9.64788C11.2107 14.8837 11.2404 14.4596 11.3149 13.3284L11.7986 5.83448C11.8209 5.52936 12.0888 5.29866 12.3939 5.31355C12.699 5.33587 12.9372 5.59634 12.9148 5.90889L12.4311 13.4028C12.3493 14.5637 12.2451 16 9.64788 16Z" fill="#FFFFFF" />
                            <path d="M8.49403 11.9069H6.0159C5.71079 11.9069 5.45776 11.6539 5.45776 11.3488C5.45776 11.0437 5.71079 10.7906 6.0159 10.7906H8.49403C8.79915 10.7906 9.05217 11.0437 9.05217 11.3488C9.05217 11.6539 8.79915 11.9069 8.49403 11.9069Z" fill="#FFFFFF" />
                            <path d="M9.11914 8.93024H5.39823C5.09311 8.93024 4.84009 8.67722 4.84009 8.3721C4.84009 8.06699 5.09311 7.81396 5.39823 7.81396H9.11914C9.42426 7.81396 9.67728 8.06699 9.67728 8.3721C9.67728 8.67722 9.42426 8.93024 9.11914 8.93024Z" fill="#FFFFFF" />
                        </svg>
                    </button>)
                    : (<button
                        type="button"
                        className="epf-upload-trigger bg-blue-500 rounded-full p-2 flex items-center justify-center cursor-pointer"
                        onClick={() => fileInputRef.current.click()}
                        aria-label="Upload Profile Picture"
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M17.6294 11.2078H1.98252C1.18062 11.2078 0.515625 10.5428 0.515625 9.74094C0.515625 8.93904 1.18062 8.27405 1.98252 8.27405H17.6294C18.4313 8.27405 19.0963 8.93904 19.0963 9.74094C19.0963 10.5428 18.4313 11.2078 17.6294 11.2078Z"
                                fill="white"
                            />
                            <path
                                d="M9.80771 19.0313C9.00581 19.0313 8.34082 18.3663 8.34082 17.5644V1.91752C8.34082 1.11561 9.00581 0.450623 9.80771 0.450623C10.6096 0.450623 11.2746 1.11561 11.2746 1.91752V17.5644C11.2746 18.3663 10.6096 19.0313 9.80771 19.0313Z"
                                fill="white"
                            />
                        </svg>
                    </button>)}

                <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden"
                    onChange={handleImageUpload}
                    accept="image/*"
                />
            </div>

            <div className="epf-resume-block flex flex-col items-start">
                <div className="d-flex justify-content-between align-items-center">
                    <div style={{ fontSize: "13px" }} className="epf-resume-prompt">Upload Your Resume</div>
                    <div className='d-flex align-items-center gap-4 mt-2'>
                        {updatedData.student_resume_url && (<div
                            onClick={() => {
                                if (updatedData?.student_resume_url) {
                                    window.open(updatedData?.student_resume_url, "_blank");
                                } else {
                                    toast.error("Resume URL not available!");
                                }
                            }}
                            className="add_resume_text text-sm text-red-600 mb-2"
                            style={{ fontSize: "13px", color: "#28a745" }}>Preview Resume</div>)}
                        <div
                            onClick={() => resumeInputRef.current.click()}
                            className="add_resume_text text-sm text-red-600 mb-2"
                            style={{ fontSize: "13px" }}
                        >
                            {resumeFile ? "Resume Added" : "Add Resume"}
                        </div>
                    </div>
                </div>
                <div
                    className="epf-format-info flex items-center text-xs text-gray-500 mb-2 student_epf_format_info"
                    onClick={() => resumeInputRef.current.click()}
                >
                    <span className="epf-format-icon mr-2">
                        <svg
                            width="30"
                            height="33"
                            viewBox="0 0 30 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M14.5431 12.0712C14.3942 12.0712 14.2603 12.0414 14.1114 11.9819C13.6947 11.8181 13.4268 11.4014 13.4268 10.9549V2.02445C13.4268 1.4142 13.9328 0.908142 14.5431 0.908142C15.1533 0.908142 15.6594 1.4142 15.6594 2.02445V8.26086L16.731 7.18921C17.1627 6.75757 17.8771 6.75757 18.3087 7.18921C18.7404 7.62085 18.7404 8.33528 18.3087 8.76692L15.3319 11.7437C15.1235 11.9521 14.8259 12.0712 14.5431 12.0712Z"
                                fill="#F38D00"
                            />
                            <path
                                d="M14.5415 12.0731C14.2587 12.0731 13.9759 11.9689 13.7527 11.7457L10.7759 8.76887C10.3442 8.33723 10.3442 7.6228 10.7759 7.19116C11.2075 6.75952 11.9219 6.75952 12.3536 7.19116L15.3304 10.168C15.762 10.5996 15.762 11.314 15.3304 11.7457C15.1071 11.9689 14.8243 12.0731 14.5415 12.0731Z"
                                fill="#F38D00"
                            />
                            <path
                                d="M20.4968 32.9082H8.58958C0.03125 32.9082 0.03125 28.3685 0.03125 24.3498V22.8614C0.03125 19.5423 0.03125 15.7915 7.10117 15.7915C8.87237 15.7915 9.52727 16.2231 10.4501 16.9078C10.4947 16.9525 10.5543 16.9822 10.5989 17.0418L12.1171 18.6492C13.3971 20.0037 15.719 20.0037 16.9991 18.6492L18.5172 17.0418C18.5619 16.9971 18.6065 16.9525 18.6661 16.9078C19.5889 16.2083 20.2438 15.7915 22.015 15.7915C29.0849 15.7915 29.0849 19.5423 29.0849 22.8614V24.3498C29.0551 30.0355 26.1825 32.9082 20.4968 32.9082ZM7.10117 18.0241C2.26386 18.0241 2.26386 19.5423 2.26386 22.8614V24.3498C2.26386 28.4281 2.26386 30.6755 8.58958 30.6755H20.4968C24.9323 30.6755 26.8225 28.7853 26.8225 24.3498V22.8614C26.8225 19.5423 26.8225 18.0241 21.9852 18.0241C20.9136 18.0241 20.6903 18.1581 20.0503 18.6344L18.6065 20.1674C17.5349 21.2986 16.0911 21.9237 14.5432 21.9237C12.9953 21.9237 11.5515 21.2986 10.4799 20.1674L9.0361 18.6344C8.39608 18.1581 8.17282 18.0241 7.10117 18.0241Z"
                                fill="#F38D00"
                            />
                            <path
                                d="M4.129 18.0244C3.51875 18.0244 3.0127 17.5183 3.0127 16.9081V10.9544C3.0127 8.06693 3.01269 4.47988 8.49002 3.95894C9.10027 3.8994 9.65098 4.34592 9.71052 4.97105C9.77005 5.5813 9.32353 6.13201 8.6984 6.19154C5.2453 6.50411 5.2453 7.90321 5.2453 10.9544V16.9081C5.2453 17.5183 4.73924 18.0244 4.129 18.0244Z"
                                fill="#F38D00"
                            />
                            <path
                                d="M24.9616 18.025C24.3514 18.025 23.8453 17.5189 23.8453 16.9087V10.955C23.8453 7.90382 23.8453 6.50472 20.3922 6.17727C19.782 6.11773 19.3354 5.56702 19.395 4.95678C19.4545 4.34653 19.9903 3.88513 20.6155 3.95955C26.0928 4.48049 26.0928 8.06754 26.0928 10.955V16.9087C26.0779 17.5189 25.5719 18.025 24.9616 18.025Z"
                                fill="#F38D00"
                            />
                        </svg>
                    </span>
                    <span className='d-grid'>
                        <span className="epf-format-text">
                            Supported Formats: DOCX, DOC, PDF
                            <br />
                            Max Size: 700KB
                        </span>
                        {uploadProgress > 0 && (
                            <div
                                className={`progress-bar ${uploadStatus === "success" ? "bg_green_500" : "bg_red_500"
                                    }`}
                                style={{
                                    width: `${uploadProgress}%`,
                                    height: "5px",
                                    transition: "width 0.5s ease",
                                }}
                            ></div>
                        )}
                    </span>
                </div>
                <input
                    type="file"
                    ref={resumeInputRef}
                    className="hidden"
                    onChange={handleResumeUpload}
                    accept=".docx,.doc,.pdf"
                />
            </div>

        </div>
        <div className="pt-4 pb-4">
            <div
                className="student_epf-form-container"
                style={isSubmitted ? { position: "relative" } : { display: "block" }}
            >
                {isSubmitted && isEditModelOpen === false && (
                    <div className="epf_edit_Details_button student_epf_details_button" onClick={handleEditClick}>
                        <b>
                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2.23933 11.3489C1.80213 11.3489 1.40212 11.1908 1.10445 10.9024C0.750961 10.5489 0.592801 10.0466 0.676522 9.50703L0.936986 7.66517C0.9928 7.26517 1.24398 6.75354 1.53235 6.46517L6.36026 1.63726C8.01607 -0.0185494 9.45793 0.725636 10.3696 1.63726C11.0858 2.35354 11.4114 3.10703 11.337 3.86052C11.2812 4.47447 10.9556 5.05122 10.3696 5.64656L5.54165 10.4745C5.25328 10.7628 4.75094 11.014 4.34164 11.0791L2.4998 11.3396C2.41608 11.3396 2.32306 11.3489 2.23933 11.3489ZM8.36025 2.04657C8.01607 2.04657 7.7091 2.26982 7.35561 2.61401L2.5277 7.44191C2.45329 7.51633 2.34166 7.74889 2.32305 7.85122L2.06259 9.69308C2.05329 9.7861 2.06257 9.86982 2.09978 9.90703C2.13699 9.94424 2.22072 9.95354 2.31374 9.94424L4.15561 9.68377C4.26724 9.66517 4.4905 9.55354 4.56492 9.47912L9.39283 4.65122C9.74631 4.29773 9.93235 3.99075 9.96025 3.71168C9.98816 3.3954 9.80213 3.02331 9.39283 2.61401C8.98352 2.22331 8.65793 2.04657 8.36025 2.04657Z"
                                    fill="#F38D00"
                                />
                            </svg>
                            <span className="pl-4"> Edit Details</span>{" "}
                        </b>
                    </div>
                )}
                {isEditModelOpen ? (
                    <>
                        <div className='student_my_profile_summary' style={{ width: "100%" }} >
                            <p>
                                <b>Edit Profile Summary:</b>
                            </p>
                            <textarea
                                name='bio'
                                // value={updatedData.about || ""}
                                placeholder="Edit Your Profile Summary"
                                value={
                                    !initialValuesSet.bio
                                        ? updatedData?.about || ""
                                        : formData.bio
                                }
                                onChange={(e) => handleInputEditChange("bio", e.target.value)}
                                rows={3}
                                style={{ width: '100%', resize: 'vertical' }}
                            />
                        </div> <br />

                        <form className="epf-form-layout" onSubmit={editPersonalDetails}>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.firstName ? "input-error" : ""
                                        }`}
                                    placeholder="First Name"
                                    name="firstName"
                                    // value={
                                    //     // capitalizeFirstLetter(formData.firstName) ||
                                    //     updatedData?.first_name || ""
                                    // }
                                    // onChange={(e) => handleInputChangeWithValidation(e)}
                                    value={
                                        !initialValuesSet.firstName
                                            ? updatedData?.first_name || ""
                                            : formData.firstName
                                    }
                                    onChange={(e) => {
                                        handleInputEditChange("firstName", e.target.value);
                                        // handleInputChangeWithValidation(e);
                                    }}
                                />
                                {errors.firstName && (
                                    <span className="error-message">
                                        First letter should be capitalized
                                    </span>
                                )}
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Last Name"
                                    name="lastName"
                                    // value={
                                    //     // capitalizeFirstLetter(formData.lastName) || ""
                                    // }
                                    // onChange={(e) => handleInputChangeWithValidation(e)}
                                    value={
                                        !initialValuesSet.lastName
                                            ? updatedData?.last_name || ""
                                            : formData.lastName
                                    }
                                    onChange={(e) => {
                                        handleInputEditChange("lastName", e.target.value);
                                        // handleInputChangeWithValidation(e); 
                                    }}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Enter your Email"
                                    name="email"
                                    value={updatedData.email || formData.email}
                                    disabled
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Enter your Collage Name"
                                    name="email"
                                    value={updatedData?.student_campus_clg_nam || collegeName || "N/A"}
                                    disabled
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Enter your phone number"
                                    name="phone"
                                    type="text"
                                    // value={formData.phone || updatedData?.phone_no || ''}
                                    // onChange={handleInputChange}
                                    value={
                                        !initialValuesSet.phone
                                            ? updatedData?.phone_no || ""
                                            : formData.phone
                                    }
                                    onChange={(e) => handleInputEditChange("phone", e.target.value)}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Date of Birth"
                                    name="dob"
                                    type="date"
                                    // value={formData.dob || updatedData?.dob}
                                    // onChange={handleInputChange}
                                    value={
                                        !initialValuesSet.dob
                                            ? updatedData?.dob || ""
                                            : formData.dob
                                    }
                                    onChange={(e) => handleInputEditChange("dob", e.target.value)}
                                    onFocus={(e) => {
                                        e.target.type = "date";
                                        e.target.max = maxDate;
                                    }}
                                    onBlur={(e) => (e.target.type = "text")}
                                />
                            </div>

                            <div className="epf-input-wrapper epf-input-gap">
                                <select
                                    name="gender"
                                    // value={formData.gender || updatedData?.gender}
                                    // onChange={handleInputChange}
                                    value={
                                        !initialValuesSet.gender
                                            ? updatedData?.gender || ""
                                            : formData.gender
                                    }
                                    onChange={(e) => handleInputEditChange("gender", e.target.value)}
                                    className={`epf-input-field ${errors.gender ? "input-error" : ""
                                        }`}
                                >
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="others">Others</option>
                                </select>
                                {/* {errors.gender && (
                                    <span className="error-text">{errors.gender}</span>
                                )} */}
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Current Location"
                                    name="currentLocation"
                                    // value={
                                    //     formData.currentLocation || updatedData?.current_location
                                    // }
                                    // onChange={handleInputChange}
                                    value={
                                        !initialValuesSet.currentLocation
                                            ? updatedData?.current_location || ""
                                            : formData.currentLocation
                                    }
                                    onChange={(e) => handleInputEditChange("currentLocation", e.target.value)}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Preferred Location"
                                    name="preferredLocation"
                                    // value={
                                    //     formData.preferredLocation ||
                                    //     updatedData?.preferred_location
                                    // }
                                    // onChange={handleInputChange}
                                    value={
                                        !initialValuesSet.preferredLocation
                                            ? updatedData?.preferred_location || ""
                                            : formData.preferredLocation
                                    }
                                    onChange={(e) => handleInputEditChange("preferredLocation", e.target.value)}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Home State"
                                    name="homeState"
                                    // value={formData.homeState || updatedData?.state}
                                    // onChange={handleInputChange}
                                    value={
                                        !initialValuesSet.homeState
                                            ? updatedData?.state || ""
                                            : formData.homeState
                                    }
                                    onChange={(e) => handleInputEditChange("homeState", e.target.value)}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Home City"
                                    name="homeCity"
                                    // value={formData.homeCity || updatedData?.city}
                                    // onChange={handleInputChange}
                                    value={
                                        !initialValuesSet.homeCity
                                            ? updatedData?.city || ""
                                            : formData.homeCity
                                    }
                                    onChange={(e) => handleInputEditChange("homeCity", e.target.value)}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className="epf-input-field"
                                    placeholder="Expected Salary"
                                    name="expectedSalary"
                                    // value={
                                    //     formData.expectedSalary || updatedData?.expected_salary
                                    // }
                                    // onChange={handleInputChange}
                                    value={
                                        !initialValuesSet.expectedSalary
                                            ? updatedData?.expected_salary || ""
                                            : formData.expectedSalary
                                    }
                                    onChange={(e) => handleInputEditChange("expectedSalary", e.target.value)}
                                />
                            </div>

                            <div className="d-flex gap-4">
                                <button type="submit" className="epf-submit-btn mt-0">
                                    {isLoading ? <span className='spinner'></span> : `Save`}
                                </button>
                                <button
                                    onClick={handleEditCancel}
                                    className="epf-submit-btn mt-0"
                                    style={{
                                        background: "transparent",
                                        border: "1px solid rgba(243, 141, 0, 1)",
                                        color: "rgba(243, 141, 0, 1)",
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </>
                ) : null}
                {isSubmitted === true && isEditModelOpen === false ? (<>

                    <div className="submitted-data-container student_submitted_data_contianer">

                        <div className="submitted-data-column">
                            <p>
                                <b>First Name:</b> {updatedData?.first_name || "N/A"}
                            </p>
                            <p>
                                <b>Last Name:</b> {updatedData?.last_name || "N/A"}
                            </p>
                            <p>
                                <b>Email:</b> {updatedData?.email || "N/A"}
                            </p>
                            <p>
                                <b>College Name:</b> {updatedData?.student_campus_clg_name || collegeName || "Not Mentioned"}
                            </p>
                            <p>
                                <b>Phone:</b> {updatedData?.phone_no || "N/A"}
                            </p>
                        </div>
                        <div className="submitted-data-column">
                            <p>
                                <b>DOB:</b> {updatedData?.dob || "N/A"}
                            </p>
                            <p>
                                <b>Gender:</b> {updatedData?.gender || "N/A"}
                            </p>
                            <p>
                                <b>Current Location:</b>{" "}
                                {updatedData?.current_location || "N/A"}
                            </p>
                            <p>
                                <b>Preferred Location:</b>{" "}
                                {updatedData?.preferred_location || "N/A"}
                            </p>

                        </div>
                        <div className="submitted-data-column">
                            <p>
                                <b>Home State:</b> {updatedData?.state || "N/A"}
                            </p>
                            <p>
                                <b>Home City:</b> {updatedData?.city || "N/A"}
                            </p>
                            <p>
                                <b>Expected Salary:</b>{" "}
                                {`${updatedData?.expected_salary || "N/A"} LPA`}
                            </p>
                        </div>
                    </div>
                    <div className='student_my_profile_summary' >
                        <p>
                            <b>My Profile Summary:</b>
                        </p>
                        <textarea
                            // name='bio'
                            value={formData.bio}
                            placeholder={updatedData?.about}
                            // onChange={handleInputChange}
                            disabled
                            rows={3}
                            style={{ width: '100%', resize: 'vertical' }}
                        />
                    </div>
                </>) : (
                    isEditModelOpen === false &&
                    isSubmitted === false && (<>
                        <div className='student_my_profile_summary' style={{ width: "100%" }} >
                            <p>
                                <b>Add Profile Summary:</b>
                            </p>
                            <textarea
                                name='bio'
                                value={formData.bio}
                                placeholder='Add Your Proifle Summary'
                                onChange={handleInputChange}
                                rows={3}
                                style={{ width: '100%', resize: 'vertical' }}
                                className={errors.bio ? "input-error" : ""}
                            />
                            {errors.bio && (
                                <span className="error-text">{errors.bio}</span>
                            )}
                        </div> <br />
                        <form className="epf-form-layout" onSubmit={handlePersonalSubmit}>
                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.firstName ? "input-error" : ""
                                        }`}
                                    placeholder="First Name"
                                    name="firstName"
                                    value={
                                        capitalizeFirstLetter(formData.firstName) ||
                                        capitalizeFirstLetter(updatedData?.first_name) ||
                                        ""
                                    }
                                    onChange={handleInputChange}
                                />
                                {errors.firstName && (
                                    <span className="error-message">
                                        First letter should be capitalized
                                    </span>
                                )}
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.lastName ? "input-error" : ""
                                        }`}
                                    placeholder="Last Name"
                                    name="lastName"
                                    value={formData.lastName || updatedData?.last_name || ""}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field`}
                                    placeholder="Enter your Email"
                                    name="email"
                                    value={updatedData?.email || ""}
                                    readOnly
                                    style={{ cursor: "no-drop" }}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field`}
                                    placeholder="Enter your College"
                                    name="email"
                                    value={updatedData?.student_campus_clg_name || collegeName || ""}
                                    readOnly
                                    style={{ cursor: "no-drop" }}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.phone ? "input-error" : ""
                                        }`}
                                    placeholder="Enter your phone number"
                                    name="phone"
                                    type="number"
                                    value={
                                        formData.phone ||
                                        updatedData?.phone_no?.replace("+91", "")
                                    }
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value.length <= 10) {
                                            handleInputChange(e);
                                        }
                                    }}
                                />
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.dob ? "input-error" : ""
                                        }`}
                                    placeholder="Enter your DOB"
                                    name="dob"
                                    type="text"
                                    value={formData.dob}
                                    onChange={handleInputChange}
                                    onFocus={(e) => {
                                        e.target.type = "date";
                                        e.target.max = maxDate;
                                    }}
                                    onBlur={(e) => (e.target.type = "text")}
                                />
                                {errors.dob && (
                                    <span className="error-text">{errors.dob}</span>
                                )}
                            </div>

                            <div className="epf-input-wrapper epf-input-gap">
                                <select
                                    name="gender"
                                    value={formData.gender}
                                    onChange={handleInputChange}
                                    className={`epf-input-field ${errors.gender ? "input-error" : ""
                                        }`}
                                >
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="others">Others</option>
                                </select>
                                {errors.gender && (
                                    <span className="error-text">{errors.gender}</span>
                                )}
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.currentLocation ? "input-error" : ""
                                        }`}
                                    placeholder="Current Location"
                                    name="currentLocation"
                                    value={formData.currentLocation}
                                    onChange={handleInputChange}
                                />
                                {errors.currentLocation && (
                                    <span className="error-text">{errors.currentLocation}</span>
                                )}
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.preferredLocation ? "input-error" : ""
                                        }`}
                                    placeholder="Preferred Location"
                                    name="preferredLocation"
                                    value={formData.preferredLocation}
                                    onChange={handleInputChange}
                                />
                                {errors.preferredLocation && (
                                    <span className="error-text">
                                        {errors.preferredLocation}
                                    </span>
                                )}
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.homeState ? "input-error" : ""
                                        }`}
                                    placeholder="Home State"
                                    name="homeState"
                                    value={formData.homeState}
                                    onChange={handleInputChange}
                                />
                                {errors.homeState && (
                                    <span className="error-text">{errors.homeState}</span>
                                )}
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.homeCity ? "input-error" : ""
                                        }`}
                                    placeholder="Home City"
                                    name="homeCity"
                                    value={formData.homeCity}
                                    onChange={handleInputChange}
                                />
                                {errors.homeCity && (
                                    <span className="error-text">{errors.homeCity}</span>
                                )}
                            </div>

                            <div className="epf-input-wrapper">
                                <input
                                    className={`epf-input-field ${errors.expectedSalary ? "input-error" : ""
                                        }`}
                                    placeholder="Expected Salary (in Lakhs)"
                                    name="expectedSalary"
                                    value={formData.expectedSalary}
                                    onChange={handleInputChange}
                                />
                                {errors.expectedSalary && (
                                    <span className="error-text">{errors.expectedSalary}</span>
                                )}
                            </div>

                            <button type="submit" className="epf-submit-btn mt-0">
                                {isLoading ? <span className='spinner'></span> : `Save`}
                            </button>
                        </form>
                    </>)
                )}
            </div>
        </div>
    </>)
};

export default PersonalInformation;